export default {
  namespaced: true,
  state: {
    wishlist: []
  },
  getters: {
    wishlist: state => state.wishlist
  },
  mutations: {
    addToWishlist (state, element) {
      var found = state.wishlist.find((product) => {
        return product.fields.productCode === element.fields.productCode
      })
      if (!found) state.wishlist.push(element)
    },
    removeFromWishlist (state, element) {
      state.wishlist = state.wishlist.filter(product => product !== element)
    },
    clearWishlist (state) {
      state.wishlist = []
    }
  },
  actions: {
    async loadWishlist ({ commit, rootState }) {
      // TODO:
      return []
    }
  }
}
